import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  AuthService,
  BalanceQuery,
  config,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
  TMAuthService,
} from '@fgb/core';
import { firstValueFrom, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'fgb-mobile-nav-menu',
  templateUrl: './mobile-nav-menu.component.html',
  styleUrls: ['./mobile-nav-menu.component.scss'],
})
export class MobileNavMenuComponent implements OnInit, OnDestroy {
  @Input() isHomePage: boolean = false;
  @Input() isTertiary: boolean = false;

  //Rewards Page
  @Input() notDisplayNav: boolean = false;
  @Input() isPurchaseSuccessPage: boolean = false;
  @Input() isCheckOut: boolean;

  //Wallet Page
  @Input() isWallet: boolean = false;
  @Input() isWalletItem: boolean = false;
  @Input() isClaimedPage: boolean = false;
  @Input() isCampaignPage: boolean = false;
  @Input() title: string;
  pointsBalance$: Observable<number | undefined>;
  ecashBalance$: Observable<number | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  card$: Observable<MemberCard | undefined>;

  constructor(
    private authService: AuthService,
    private router: Router,
    private balanceQuery: BalanceQuery,
    private tmOauthService: TMAuthService,
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery
  ) {}
  private routerSubscription: Subscription;
  isCollapsed: boolean = false;

  ngOnInit() {
    this.initMemberAccounts();
  }

  initMemberAccounts() {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.ecashBalance$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.card$ = this.memberCardQuery.selectCurrentCard();
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  logout() {
    firstValueFrom(this.authService.logout()).then(() => this.router.navigate(['/login']));
  }

  loginWithCard(memberId: string) {
    firstValueFrom(this.authService.switchUser(memberId));
  }

  async connectToTM() {
    this.tmOauthService.ssoToModernAccountRedirect();
  }

  getDynamicRoute(): string[] {
    if (this.isPurchaseSuccessPage || this.isCheckOut) {
      return ['/rewards'];
    } else if (this.isWalletItem || this.isClaimedPage || this.isCampaignPage) {
      return ['/rewards/wallet'];
    } else if (this.isWallet || this.isTertiary) {
      return ['/'];
    } else {
      return ['/']; // fallback route if needed
    }
  }

  isRootRoute(): boolean {
    return this.getDynamicRoute()[0] === '/';
  }
}
